module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-23.d526b5e1.png";